import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BenefitCategoryData {
  benefitsData: {};
}

const benefitSlice = createSlice({
  name: 'benefitDetails',
  initialState: {
    benefitData: {},
    totalDefinedBenefitContribution: undefined as number | undefined,
  },
  reducers: {
    setBenefitData: (state, action: PayloadAction<BenefitCategoryData>) => {
      state.benefitData = action.payload;
    },
    setTotalDefinedBenefitContribution: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.totalDefinedBenefitContribution = action.payload;
    },
  },
});

const { reducer, actions } = benefitSlice;

export const { setBenefitData, setTotalDefinedBenefitContribution } = actions;

export const benefitsApi = reducer;
